const API_BASE_URL = process.env.REACT_APP_BACKEND_STAGING_URL;

class AIJobCreationService {
  async processMessage(message, conversationHistory, restaurantId, locationId = null) {
    
    const requestBody = {
      message,
      conversationHistory,
      restaurantId,
      ...(locationId && { locationId }) // Only include locationId if provided
    };


    const response = await fetch(`${API_BASE_URL}/api/chat/process`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(requestBody)
    });

   

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
    }

    const responseData = await response.json();
    
    return responseData;
  }

  async createJob(extractedData, restaurantId, locationId) {
    const response = await fetch(`${API_BASE_URL}/api/ai-job-creation/create-job`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        extractedData,
        restaurantId,
        locationId
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }
}

export const aiJobCreationService = new AIJobCreationService();
